import React from "react";
import ServiceTemplate from "./ServiceTemplate";
import { Wind } from "lucide-react";

const serviceData = {
  id: "climatisation",
  title: "Climatisation",
  description: "Solutions de climatisation professionnelles",
  icon: Wind,
  image: "/Climatisation.jpg", // Updated path
  longDescription: [
    "Nos solutions de climatisation professionnelle garantissent un confort thermique optimal pour vos espaces de travail. Nous concevons et installons des systèmes adaptés à vos besoins spécifiques.",
    "De l'installation à la maintenance, nous assurons la performance et l'efficacité énergétique de vos systèmes de climatisation, tout en respectant les normes environnementales en vigueur.",
  ],
  features: [
    "Installation de systèmes de climatisation",
    "Climatisation centralisée",
    "Solutions multi-split",
    "Systèmes VRV/VRF",
    "Régulation intelligente",
    "Maintenance préventive",
  ],
  benefits: [
    "Confort thermique optimal",
    "Économies d'énergie",
    "Contrôle précis de la température",
    "Maintenance régulière assurée",
    "Solutions écologiques",
  ],
};

const Climatisation = () => {
  return <ServiceTemplate service={serviceData} />;
};

export default Climatisation;
